<!--min order-->
@if (viewType === 'grid-item') {
  @if (product) {
    <div class="min-max--container" [ngClass]="fontSize">
      @if (!showAvailableQuantity && !isRecommended) {
        @if (showMinQuantity) {
          <div
            [class.min-order__met]="moqMet"
            class="min-order__not-met"
            [ngClass]="classes"
          >
            <strong
              >{{ totalQuantity }}/{{ product.skus[0].min_quantity }}</strong
            >
            <span>&nbsp;Min Order Qty</span>
          </div>
        }
        @if (groupQuantityVisible) {
          <div
            [class.min-order__met]="groupMoqMet"
            class="group-min-order min-order__not-met"
            [ngClass]="classes"
          >
            <strong>{{ groupQuantity }}/{{ groupMinQuantity }}</strong>
            <span>&nbsp;{{ groupMinOrderTitle }}</span>
          </div>
        }
      }
      @if (showAvailableQuantity && shouldShowAvailableQuantity) {
        <div
          [class.max-order__met]="maxQtyMet"
          class="max-order__not-met"
          [ngClass]="classes"
        >
          <strong>{{ availableQuantity }}</strong>
          <span>&nbsp;Available Quantity</span>
        </div>
      }
    </div>
  }
} @else {
  @if (product) {
    <div class="min-max--container vertical" [ngClass]="fontSize">
      @if (!showAvailableQuantity && !isRecommended) {
        @if (showMinQuantity) {
          <div
            [class.min-order__met]="moqMet"
            class="min-order__not-met"
            [ngClass]="classes"
          >
            <span>Minimum Order Quantity: </span>
            @if (showQuantityInSeparateLine) {
              <br />
            }
            <strong class="fw-normal"
              >{{ totalQuantity }}/{{ minQuantity }}</strong
            >
          </div>
        }
        @if (groupQuantityVisible) {
          <div
            [class.min-order__met]="groupMoqMet"
            class="group-min-order min-order__not-met"
            [ngClass]="classes"
          >
            <span>{{ groupMinOrderTitle }}: </span>
            @if (showQuantityInSeparateLine) {
              <br />
            }
            <strong class="fw-normal"
              >{{ groupQuantity }}/{{ groupMinQuantity }}</strong
            >
          </div>
        }
      }
      @if (showAvailableQuantity && shouldShowAvailableQuantity) {
        <div
          [class.max-order__met]="maxQtyMet"
          class="max-order__not-met"
          [ngClass]="classes"
        >
          <span>Available Quantity: </span>
          @if (showQuantityInSeparateLine) {
            <br />
          }
          <strong class="fw-normal">{{ availableQuantity }}</strong>
        </div>
      }
    </div>
  }
}
